import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.3-1.6 3.9-5.5 3.9-3.3 0-6-2.8-6-6.1s2.7-6.1 6-6.1c1.9 0 3.1.8 3.8 1.4l2.6-2.5C16.7 3 14.5 2 12 2 6.5 2 2 6.5 2 12s4.5 10 10 10c5.8 0 9.6-4.1 9.6-9.8 0-.7-.1-1.3-.2-2H12z" />
      <path fill="#34A853" d="M3.1 7.3l3.2 2.4C7 7.8 9.3 6 12 6c1.9 0 3.1.8 3.8 1.4l2.6-2.5C16.7 3 14.5 2 12 2c-3.8 0-7.1 2.2-8.9 5.3z" />
      <path fill="#FBBC05" d="M12 22c2.4 0 4.5-.8 6.1-2.3l-2.8-2.3c-.8.6-1.9 1-3.3 1-2.7 0-5-1.8-5.8-4.3l-3.2 2.5C4.8 19.8 8.1 22 12 22z" />
      <path fill="#4285F4" d="M21.6 12.2c0-.7-.1-1.3-.2-2H12v3.9h5.5c-.3 1.3-1.1 2.4-2.2 3.1l2.8 2.3c2-1.9 3.5-4.7 3.5-7.3z" />
    </svg>
  );
}

export default function LoginPage() {
  const { loginWithGoogle, loginWithEmail, registerWithEmail, resetPassword } = useAuth();
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState("login-email");
  const [profileName, setProfileName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const mapAuthError = (err) => {
    const map = {
      "auth/popup-closed-by-user": "חלון ההתחברות נסגר לפני השלמה.",
      "auth/cancelled-popup-request": "בקשת התחברות בוטלה.",
      "auth/user-disabled": "החשבון קיים אך אינו פעיל. פנה לרכז להפעלה.",
      "auth/not-authorized": "החשבון לא מוגדר במערכת. פנה לרכז להוספה.",
      "auth/no-email": "לא נמצא אימייל בחשבון.",
      "auth/invalid-email": "כתובת האימייל לא תקינה.",
      "auth/invalid-credential": "אימייל או סיסמה שגויים. אם אין חשבון, עבור ללשונית הרשמה.",
      "auth/wrong-password": "אימייל או סיסמה שגויים.",
      "auth/user-not-found": "לא נמצא משתמש עם האימייל הזה.",
      "auth/email-already-in-use": "האימייל כבר רשום במערכת.",
      "auth/weak-password": "הסיסמה חלשה מדי (לפחות 6 תווים).",
      "auth/too-many-requests": "יותר מדי ניסיונות. נסה שוב בעוד כמה דקות.",
      "auth/missing-email": "יש להזין אימייל לפני איפוס סיסמה.",
    };
    return map[err?.code] || err?.message || "התחברות נכשלה";
  };

  const handleGoogleSignIn = async () => {
    setError("");
    setNotice("");
    setLoading(true);
    try {
      await loginWithGoogle();
    } catch (err) {
      console.error(err);
      setError(mapAuthError(err));
    }
    setLoading(false);
  };

  const handleEmailAuth = async (e) => {
    e.preventDefault();
    setError("");
    setNotice("");

    if (!email.trim() || !password) {
      setError("יש למלא אימייל וסיסמה.");
      return;
    }

    if (mode === "signup-email" && !profileName.trim()) {
      setError("בהרשמה יש להזין שם מלא.");
      return;
    }

    setLoading(true);
    try {
      if (mode === "signup-email") {
        await registerWithEmail(email, password, profileName);
      } else {
        await loginWithEmail(email, password);
      }
    } catch (err) {
      console.error(err);
      setError(mapAuthError(err));
    }
    setLoading(false);
  };

  const handleForgotPassword = async () => {
    setError("");
    setNotice("");

    if (!email.trim()) {
      setError("יש להזין אימייל כדי לשלוח איפוס סיסמה.");
      return;
    }

    setLoading(true);
    try {
      await resetPassword(email);
      setNotice("נשלח מייל לאיפוס סיסמה. בדוק תיבת דואר וספאם.");
    } catch (err) {
      console.error(err);
      setError(mapAuthError(err));
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg,#171717 0%,#1a1a2e 50%,#9B1830 100%)", position: "relative", overflow: "hidden", direction: "rtl", fontFamily: "Heebo, sans-serif" }}>
      <div style={{ position: "absolute", width: 600, height: 600, borderRadius: "50%", background: "rgba(196,30,58,0.1)", top: -200, left: -200, filter: "blur(100px)" }} />
      <div style={{ background: "white", borderRadius: 24, padding: "48px 40px", width: 420, maxWidth: "90vw", boxShadow: "0 25px 80px rgba(0,0,0,0.3)", textAlign: "center", position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 8 }}>
          <div style={{ width: 76, height: 76, borderRadius: 18, background: "white", border: "1px solid #E8E8E8", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 8px 24px rgba(0,0,0,0.12)", overflow: "hidden" }}>
            <img src="/logo.png" alt="לוגו עזר מציון" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
          </div>
        </div>
        <h2 style={{ fontFamily: "Assistant", fontSize: 26, fontWeight: 800, margin: "16px 0 4px" }}>עזר מציון</h2>
        <p style={{ color: "#737373", fontSize: 14, marginBottom: 22 }}>מערכת ניהול מתנדבים מחוז דרום</p>
        <p style={{ color: "#525252", fontSize: 13, marginBottom: 18 }}>אפשר להתחבר עם Google או עם אימייל וסיסמה.</p>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 14 }}>
          <button
            type="button"
            onClick={() => setMode("login-email")}
            style={{
              border: "1px solid #E5E7EB",
              background: mode === "login-email" ? "#111827" : "#fff",
              color: mode === "login-email" ? "#fff" : "#111827",
              borderRadius: 10,
              padding: "9px 10px",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            התחברות
          </button>
          <button
            type="button"
            onClick={() => setMode("signup-email")}
            style={{
              border: "1px solid #E5E7EB",
              background: mode === "signup-email" ? "#111827" : "#fff",
              color: mode === "signup-email" ? "#fff" : "#111827",
              borderRadius: 10,
              padding: "9px 10px",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            הרשמה
          </button>
        </div>

        {error && (
          <div style={{ background: "#FEF2F2", color: "#DC2626", padding: 10, borderRadius: 10, fontSize: 13, marginBottom: 12 }}>
            {error}
          </div>
        )}
        {notice && (
          <div style={{ background: "#ECFDF5", color: "#047857", padding: 10, borderRadius: 10, fontSize: 13, marginBottom: 12 }}>
            {notice}
          </div>
        )}

        <form onSubmit={handleEmailAuth} style={{ marginBottom: 12 }}>
          {mode === "signup-email" && (
            <input
              type="text"
              placeholder="שם מלא"
              value={profileName}
              onChange={(e) => setProfileName(e.target.value)}
              style={{ width: "100%", boxSizing: "border-box", padding: "12px 14px", border: "1px solid #E5E7EB", borderRadius: 10, marginBottom: 8, fontSize: 14 }}
            />
          )}
          <input
            type="email"
            placeholder="אימייל"
            dir="ltr"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: "100%", boxSizing: "border-box", padding: "12px 14px", border: "1px solid #E5E7EB", borderRadius: 10, marginBottom: 8, fontSize: 14 }}
          />
          <input
            type="password"
            placeholder="סיסמה"
            dir="ltr"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: "100%", boxSizing: "border-box", padding: "12px 14px", border: "1px solid #E5E7EB", borderRadius: 10, marginBottom: 8, fontSize: 14 }}
          />
          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "12px 14px",
              borderRadius: 12,
              border: "1px solid #111827",
              background: "#111827",
              color: "white",
              fontSize: 15,
              fontWeight: 700,
              cursor: loading ? "wait" : "pointer",
            }}
          >
            {loading ? "ממתין..." : mode === "signup-email" ? "הרשמה עם אימייל" : "התחברות עם אימייל"}
          </button>
          {mode === "login-email" && (
            <button
              type="button"
              onClick={handleForgotPassword}
              disabled={loading}
              style={{
                marginTop: 10,
                background: "transparent",
                border: "none",
                color: "#9B1830",
                fontWeight: 700,
                cursor: loading ? "wait" : "pointer",
                textDecoration: "underline",
                fontSize: 13,
              }}
            >
              שכחתי סיסמה
            </button>
          )}
        </form>

        <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "8px 0 12px" }}>
          <div style={{ height: 1, background: "#E5E7EB", flex: 1 }} />
          <span style={{ fontSize: 12, color: "#737373" }}>או</span>
          <div style={{ height: 1, background: "#E5E7EB", flex: 1 }} />
        </div>

        <button
          type="button"
          onClick={handleGoogleSignIn}
          disabled={loading}
          style={{
            width: "100%",
            padding: "12px 14px",
            borderRadius: 12,
            border: "1px solid #E5E7EB",
            background: "white",
            color: "#111827",
            fontSize: 15,
            fontWeight: 600,
            cursor: loading ? "wait" : "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
            boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
          }}
        >
          <GoogleIcon />
          {loading ? "מתחבר..." : "התחברות עם Google"}
        </button>

        <p style={{ color: "#6B7280", fontSize: 12, marginTop: 10 }}>
          משתמש חדש נוצר אוטומטית בהרשמה עם אימייל וסיסמה.
        </p>
      </div>
    </div>
  );
}
